import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Globe, Calendar, ExternalLink } from 'lucide-react';
// ⚠️ SETUP INSTRUCTIONS:
// 1. Sign up at https://calendly.com and create an event type
// 2. Copy your Calendly URL (e.g. https://calendly.com/your-username/30min)
// 3. Replace the URL below with your actual Calendly link
const CALENDLY_URL = 'https://calendly.com/bytewebstudio/15min';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-dark-lighter" data-id="element-29">
      <div className="max-w-[1320px] mx-auto px-4" data-id="element-30">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-31">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-32">
            <h2 className="text-4xl md:text-5xl font-bold text-white font-syne mb-6" data-id="element-33">
              Let's Work <br data-id="element-34" />
              <span className="text-gold" data-id="element-35">Together</span>
            </h2>
            <p className="text-white/65 text-lg font-inter mb-12 max-w-md" data-id="element-36">
              Ready to start a project? Book a free consultation directly on my
              calendar. Pick a time that works for you and let's discuss your
              vision.
            </p>

            <div className="space-y-8" data-id="element-37">
              <div className="flex items-start gap-6 group" data-id="element-38">
                <div className="w-14 h-14 bg-dark rounded-full flex items-center justify-center text-gold border border-white/10 group-hover:border-gold transition-colors shrink-0" data-id="element-39">
                  <Phone className="w-6 h-6" data-id="element-40" />
                </div>
                <div data-id="element-41">
                  <h4 className="text-white font-syne font-bold text-xl mb-1" data-id="element-42">
                    Call Me
                  </h4>
                  <a href="tel:+27712158291" className="text-white/60 font-inter hover:text-gold transition-colors" data-id="element-43">
                    071 215 8291
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6 group" data-id="element-44">
                <div className="w-14 h-14 bg-dark rounded-full flex items-center justify-center text-gold border border-white/10 group-hover:border-gold transition-colors shrink-0" data-id="element-45">
                  <Globe className="w-6 h-6" data-id="element-46" />
                </div>
                <div data-id="element-47">
                  <h4 className="text-white font-syne font-bold text-xl mb-1" data-id="element-48">
                    Website
                  </h4>
                  <a href="https://byteweb.co.za" target="_blank" rel="noopener noreferrer" className="text-white/60 font-inter hover:text-gold transition-colors" data-id="element-49">
                    byteweb.co.za
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6 group" data-id="element-50">
                <div className="w-14 h-14 bg-dark rounded-full flex items-center justify-center text-gold border border-white/10 group-hover:border-gold transition-colors shrink-0" data-id="element-51">
                  <MapPin className="w-6 h-6" data-id="element-52" />
                </div>
                <div data-id="element-53">
                  <h4 className="text-white font-syne font-bold text-xl mb-1" data-id="element-54">
                    Location
                  </h4>
                  <p className="text-white/60 font-inter" data-id="element-55">
                    Cape Town, South Africa
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Calendar Booking */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark p-6 md:p-8 rounded-2xl border border-white/5 flex flex-col" data-id="element-56">
            {/* Header */}
            <div className="flex items-center gap-3 mb-6" data-id="element-57">
              <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center border border-gold/20" data-id="element-58">
                <Calendar className="w-6 h-6 text-gold" data-id="element-59" />
              </div>
              <div data-id="element-60">
                <h3 className="text-xl font-bold text-white font-syne" data-id="element-61">
                  Book a Consultation
                </h3>
                <p className="text-white/50 font-inter text-sm" data-id="element-62">
                  Pick a time that suits you
                </p>
              </div>
            </div>

            {/* Calendly Embed */}
            <div className="flex-1 rounded-xl overflow-hidden border border-white/10 bg-true-white min-h-[500px]" data-id="element-63">
              <iframe src={CALENDLY_URL} width="100%" height="100%" frameBorder="0" className="min-h-[500px]" title="Schedule a meeting" data-id="element-64" />
            </div>

            {/* Fallback Link */}
            <div className="mt-4 text-center" data-id="element-65">
              <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gold hover:text-white transition-colors font-inter font-medium text-sm group" data-id="element-66">
                Open in Calendly
                <ExternalLink size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-67" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}